export type PrimitiveGradingSelection =
  | {
      hskVersion: "hsk2" | "hsk3" | "hsk2026";
      script: "simplified";
      tierScope: "hsk-only" | "all-tiers";
    }
  | { script: "traditional"; tierScope: "hsk-only" | "all-tiers" };

export type PrimitiveListItem = {
  /** Direct eligible parents, deduplicated and ordered by SUBTLEX frequency. */
  compounds: string[];
  gloss: string | null;
  glyph: string;
};

export type PrimitiveBucket = { compoundCountLabel: string; glyphs: string[]; key: string };
export type PrimitiveBrowseData = { buckets: PrimitiveBucket[]; primitives: PrimitiveListItem[] };
export type PrimitiveBrowseAsset = Record<
  string,
  { all: PrimitiveBrowseData; default: PrimitiveBrowseData }
>;

export function primitiveGradingKey(grading: PrimitiveGradingSelection): string {
  return grading.script === "traditional" || grading.tierScope === "all-tiers"
    ? `${grading.script}/${grading.tierScope}`
    : `${grading.script}/${grading.hskVersion}`;
}
